import { render } from "./ExternalNSPKTransactionDetailsTable.vue?vue&type=template&id=5af4f383&ts=true"
import script from "./ExternalNSPKTransactionDetailsTable.vue?vue&type=script&lang=ts"
export * from "./ExternalNSPKTransactionDetailsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__